import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

export const PASSWORD_CHANGE_ROUTE = '/changer-mot-de-passe';

export const requiresPasswordChange = () => {
    const passwordExpirationDateStr = localStorage.getItem('passwordExpirationDate');
    const passwordExpirationDate = passwordExpirationDateStr ? new Date(passwordExpirationDateStr) : null;
    return (
        localStorage.getItem('updatedPassword') === 'false' ||
        (passwordExpirationDate && new Date() > passwordExpirationDate)
    );
};

const PasswordChangeGuard = ({ children }) => {
    const location = useLocation();
    const mustChangePassword = requiresPasswordChange();

    // Le changement obligatoire se fait sur /changer-mot-de-passe (page sans autorité requise),
    // plus sur /dashboard : les experts n'ont pas VIEW_DASHBOARD et ne doivent pas y passer.
    const onChangePage = location.pathname.includes(PASSWORD_CHANGE_ROUTE);

    useEffect(() => {
        if (mustChangePassword && !onChangePage) {
            toast.warning("Vous devez changer votre mot de passe avant de continuer.");
        }
    }, [onChangePage, mustChangePassword]);

    if (mustChangePassword && !onChangePage) {
        return <Navigate to={PASSWORD_CHANGE_ROUTE} replace />;
    }

    return children;
};

export default PasswordChangeGuard; 